import { PAYMENT_TARIFF } from '../types';
import { getParameterFromURL } from '../utils/scripts';
import { determinePaymentVersion } from '../utils/scripts/paymentVersion';
import { isK9FunnelConfig } from '../utils/scripts/k9Funnel';

// Single source of truth for the default discount shown across paywalls.
// The K9 funnel (config=customV76/customV78/customV79) runs a lower 53% discount everywhere except
// its p20 and p29 paywalls (links v76p20/v78p20/v79p20, v76p29), which keep the standard 60%.
const isK9Funnel = isK9FunnelConfig(getParameterFromURL('config'));
const keepsDefaultDiscount = ['p20', 'p29'].includes(determinePaymentVersion());
export const DEFAULT_DISCOUNT = isK9Funnel && !keepsDefaultDiscount ? 53 : 60;
// Discount used when the scratch-card discount screen is active
// (?p20v1DiscountScreenScratch=true), on every tariff.
export const SCRATCH_DISCOUNT = 61;

// Canonical "special offer" tariffs — these keep their own higher discount
// (65/70/72/77%) instead of the default discount.
export const SPECIAL_OFFER_TARIFFS: PAYMENT_TARIFF[] = [
  PAYMENT_TARIFF.V5,
  PAYMENT_TARIFF.V7,
  PAYMENT_TARIFF.V9,
  PAYMENT_TARIFF.V11,
  PAYMENT_TARIFF.V13,
  PAYMENT_TARIFF.V15,
  PAYMENT_TARIFF.V18,
  PAYMENT_TARIFF.V20,
  PAYMENT_TARIFF.V22,
  PAYMENT_TARIFF.V24,
  PAYMENT_TARIFF.V26,
  PAYMENT_TARIFF.V28,
  PAYMENT_TARIFF.V30,
  PAYMENT_TARIFF.V32,
  PAYMENT_TARIFF.V34,
  PAYMENT_TARIFF.V36,
  PAYMENT_TARIFF.V38,
  PAYMENT_TARIFF.V40,
  PAYMENT_TARIFF.V42,
  PAYMENT_TARIFF.V44,
  PAYMENT_TARIFF.V46,
];

export const isSpecialOfferTariff = (tariff?: PAYMENT_TARIFF | string | null): boolean =>
  SPECIAL_OFFER_TARIFFS.includes(tariff as PAYMENT_TARIFF);
